module.exports = __webpack_public_path__ + "img/teamtip_changer_saison-fr-600x200.a6382419.png";